<button
  type="button"
  [id]="qualification.qualification_code"
  class="btn range-btn"
  (click)="toggle()"
  [disabled]="disabled"
  #toggleButton
>
  {{ getbuttonText() }}
</button>
<div class="dropdown">
  <ul class="dropdown-menu" [class.show]="isOpen" #list>
    <li
      [ngClass]="{
        'justify-content-between': !quotaFlags.census && quotaFlags.delete,
        'd-inline-block text-end w-100': qualification.hasNestedQuotas
      }"
    >
      <a
        id="{{ qualification.qualification_code }}-add-quota"
        *ngIf="quotaFlags.add"
        class="quota-btn pull-left"
        (click)="openQuotaModal()"
        [ngClass]="{ 'btn-disabled': isQlcLiveSurvey }"
      >
        Add Quotas
      </a>
      <a *ngIf="quotaFlags.edit" class="quota-btn" (click)="openQuotaModal()">
        Edit Quota
      </a>
      <a
        *ngIf="quotaFlags.census"
        class="quota-btn"
        (click)="checkAndApplyRangeCensus()"
        [ngClass]="{ 'btn-disabled': disableCensusBtn || isQlcLiveSurvey }"
      >
        Census
      </a>
      <a
        *ngIf="quotaFlags.delete"
        class="quota-btn"
        (click)="deleteQuotas()"
        [ngClass]="{ 'btn-disabled': isQlcLiveSurvey }"
      >
        Delete Quotas
      </a>
    </li>
    <li>
      <div class="input-group">
        <input
          id="{{ qualification.qualification_code }}-minValue"
          type="text"
          class="form-control"
          [placeholder]="qualification.data[0].minPlaceholder"
          [(ngModel)]="qualification.data[0].minValue"
          [attr.maxlength]="qualification.data[0].maxlengthMin"
          psUiInputRestriction="[0-9]"
          (change)="onChange()"
        />
        <div class="input-group-prepend">
          <span class="input-group-text">to</span>
        </div>
        <input
          id="{{ qualification.qualification_code }}-maxValue"
          type="text"
          [placeholder]="qualification.data[0].maxPlaceholder"
          class="form-control"
          [attr.maxlength]="qualification.data[0].maxlengthMax"
          [(ngModel)]="qualification.data[0].maxValue"
          psUiInputRestriction="[0-9]"
          (change)="onChange()"
        />
      </div>
    </li>
  </ul>
</div>
